import { useQueryClient } from "@tanstack/react-query";

import { cosignatureKeys } from "@/features/cosignature/api/keyFactory";
import type { PostUserPermissionsPayload } from "@/core/types/(api)/permissions";
import { showToast } from "@/providers/ToastProvider";
import type { UUID } from "@/core/types";

import { usePermissionsMutation } from "./usePermissionsMutation";

type UseUpdateLcswPermissionProps = {
  userId: UUID;
  userName: string;
};

export function useUpdateLcswPermission({ userId, userName }: UseUpdateLcswPermissionProps) {
  const queryClient = useQueryClient();

  return usePermissionsMutation<Extract<PostUserPermissionsPayload, { lcsw: unknown }>>({
    onSuccess: () => {
      // Toggling LCSW changes eligibility to appear in the cosignature supervisor dropdown
      queryClient.invalidateQueries({ queryKey: cosignatureKeys.supervisors() });
      showToast([{ heading: `Permissions updated for ${userName}.` }, { delay: 500 }]);
    },
    // Payload is self-contained (no display metadata) — safe to apply optimistically both ways.
    optimisticStateResolver: (old, { lcsw }) => ({ ...old, lcsw: { ...old.lcsw, ...lcsw } }),
    userId,
    userName,
  });
}
